import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend) // Loads translations from files
  .use(LanguageDetector) // Detects user's language
  .use(initReactI18next) // Connects with React
  .init({
    fallbackLng: "en", // Fallback to English if a translation is missing
    debug: true,
  });

export default i18n;
